import { useGetFrontTipiDomandaIdCompetenze } from '@framework/api-client/api/inquiries-compile/domande-controller/domande-controller.ts';
import { useFillableSubmissionContext } from '../../FillableSubmissionContext.tsx';
import { getCompetenceLayersInfo } from './createMapSchema.ts';
import { type IMapWidget } from './IMapWidget.ts';

/**
 * Recupera l'elenco competenze dall'API per la risoluzione
 * lazy della competenza primaria nel widget mappa.
 *
 * `enabled` dice se la query può partire: senza `idTipoDomanda` (anteprima
 * admin, sezioni dati del backoffice) la lista non arriverà mai e chi
 * aspetta la risoluzione non deve restare in attesa.
 */
export function useMapCompetenceList(widget: IMapWidget, readonly?: boolean) {
  const competenceLayers = getCompetenceLayersInfo(widget);
  const { submission } = useFillableSubmissionContext();

  const hasPrimary = competenceLayers.some(
    layer => layer.competence?.role === 'primary',
  );

  const enabled = hasPrimary && submission?.idTipoDomanda != null && !readonly;

  const { data, isError, refetch } = useGetFrontTipiDomandaIdCompetenze(
    submission?.idTipoDomanda ?? 'na',
    { query: { enabled } },
  );

  return { list: data, enabled, isError, refetch };
}
